module.exports = __webpack_public_path__ + "static/media/app-store.af0798bc.png";